import { render, staticRenderFns } from "./Bumper.vue?vue&type=template&id=35dd55a4&"
import script from "./Bumper.vue?vue&type=script&lang=js&"
export * from "./Bumper.vue?vue&type=script&lang=js&"
import style0 from "./Bumper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports